var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39844 2.09961H18.5984C19.6984 2.09961 20.5984 2.99961 20.5984 4.09961V6.29961C20.5984 7.09961 20.0984 8.09961 19.5984 8.59961L15.2984 12.3996C14.6984 12.8996 14.2984 13.8996 14.2984 14.6996V18.9996C14.2984 19.5996 13.8984 20.3996 13.3984 20.6996L11.9984 21.5996C10.6984 22.3996 8.89844 21.4996 8.89844 19.8996V14.5996C8.89844 13.8996 8.49844 12.9996 8.09844 12.4996L4.29844 8.49961C3.79844 7.99961 3.39844 7.09961 3.39844 6.49961V4.19961C3.39844 2.99961 4.29844 2.09961 5.39844 2.09961Z",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.93 2.09961L6 9.99961",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.35ffe08ef3e5e68ca8ab1cbd08286b4e.svg";
export { ForwardRef as ReactComponent };